export default {
    NEXT: 'ImageModalElementNext',
    PREV: 'ImageModalElementPrev',
};
